import axios from "axios";
import { ApiUrl } from "../utils/modules";
import { header } from "../utils/modules";

class UserServices {
  constructor(api) {
    this.api = api;
  }
  getAll(params = {}) {
    return this.api.get(ApiUrl + "utilisateur", {
      params,
    });
  }

  getOne(id) {
    return this.api.get(ApiUrl + `utilisateur/${id}`);
  }

  create(query = "", data) {
    const headers = data instanceof FormData ? { "Content-Type": "multipart/form-data" } : {};
    return this.api.post(ApiUrl + "utilisateur" + query, data, { headers });
  }  

  update(query = "", id, data) {
    const headers = data instanceof FormData ? { "Content-Type": "multipart/form-data" } : {};
    return this.api.put(ApiUrl + `utilisateur/${id}` + query, data, { headers });
  }
}

export default UserServices;
